<template>
  <w-icon-wrapper
    :height='24'
    :width='24.001'
    icon-name='work-printer-icon'
    view-box='0 0 24.001 24'
  >
    <path
      id="_97_Drucker_Icon"
      data-name="97 Drucker_Icon"
      d="M5,14H19v8H5ZM2,8H22V18H21V12H3v6H2ZM5,2H19V6H5ZM3,0V6H0V20H3v4H21V20h3V6H21V0Z"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconPrinter' };
</script>
